import axios from "axios";
import { HOST_URL } from "../constants/Constants";

export const getAllProjects = async () => {
  const data = await axios
    .get(HOST_URL + "/projects/getAllProjects")
    .catch((error) => {
      console.log("error = ", error);
    });
  return data.data;
};

export const getProjectAssets = async (projectId) => {
  const data = await axios
    .get(HOST_URL + "/projects/getProjectAssets?id=" + projectId)
    .catch((error) => {
      console.log("error = ", error);
    });
  return data.data;
};

export const getProjectAssetTasks = async (projectId) => {
  const data = await axios({
    method: "get",
    url: HOST_URL + "/projects/getProjectAssetTasks",
    withCredentials: true,
    params: { projectId },
  });
  return data.data;
};

export const getAllProjectUsers = async (projectId) => {
  const data = await axios({
    method: "get",
    url: HOST_URL + "/projects/getAllProjectUsers",
    withCredentials: true,
    params: { projectId },
  });
  return data.data;
};

export const fetchProjectUserDetails = async (projectId, userEmail) => {
  const data = await axios({
    method: "get",
    url: HOST_URL + "/projects/getProjectUserDetails",
    withCredentials: true,
    params: {
      userEmail,
      projectId,
    },
  });
  return data.data;
};

export const addProjectUser = async (
  selectedUser,
  selectedProject,
  selectedRole,
  isAdmin,
) => {
  const data = await axios({
    method: "post",
    url: HOST_URL + "/forgedata/addUserToProject",
    withCredentials: true,
    data: {
      selectedUser,
      selectedProject,
      selectedRole,
      isAdmin,
    },
  });
  return data.data;
};

export const deleteProjectUser = async (user, selectedProject) => {
  const data = await axios({
    method: "post",
    url: HOST_URL + "/forgedata/deleteUserFromProject",
    withCredentials: true,
    data: {
      user,
      selectedProject,
    },
  });
  return data.data;
};

export const addAsset = async (
  projectId,
  assetInfo,
  user,
  mviewDocNumbers,
  regionCode,
) => {
  const data = await axios({
    method: "post",
    url: HOST_URL + "/projects/addAsset",
    withCredentials: true,
    data: { projectId, assetInfo, user, mviewDocNumbers, regionCode },
  });
  return data;
};

export const addSurvey = async (
  projectId,
  task,
  user,
  maxNumber,
  regionCode,
  company,
  asset,
  subContractorNumber,
) => {
  const data = await axios({
    method: "post",
    url: HOST_URL + "/projects/addSurvey",
    withCredentials: true,
    data: {
      projectId,
      task,
      user,
      maxNumber,
      regionCode,
      company,
      asset,
      subContractorNumber,
    },
  });
  return data;
};

export const addTask = async (projectId, user, task, newNumber, regionCode) => {
  const data = await axios({
    method: "post",
    url: HOST_URL + "/projects/addCustomTask",
    withCredentials: true,
    data: {
      projectId,
      user,
      task,
      newNumber,
      regionCode,
    },
  });
  return data;
};

// export const addDrawingSet = async (
//   projectId,
//   drawingSetName,
//   regionCode,
//   disciplineCode,
//   description
// ) => {
//   const data = await axios({
//     method: "post",
//     url: HOST_URL + "/projects/addDrawingSet",
//     withCredentials: true,
//     data: {
//       projectId,
//       drawingSetName,
//       regionCode,
//       disciplineCode,
//       description,
//     },
//   });
//   return data;
// };
export const addDrawingSet = async (
  projectId,
  asset,
  assetFilters,
  company,
  location,
  modelName,
  discipline,
) => {
  const data = await axios({
    method: "post",
    url: HOST_URL + "/projects/addDrawingSet",
    withCredentials: true,
    data: {
      projectId,
      asset,
      assetFilters,
      company,
      location,
      modelName,
      discipline,
    },
  });
  return data;
};

export const deleteProjectAsset = async (assetId, accProjectId) => {
  const data = await axios({
    method: "post",
    url: HOST_URL + "/projects/deleteProjectAsset",
    withCredentials: true,
    params: { assetId, accProjectId },
  });
  return data.data;
};

export const deleteProjectAssetTasks = async (id, projectId) => {
  const data = await axios({
    method: "post",
    url: HOST_URL + "/projects/deleteProjectAssetTasks",
    withCredentials: true,
    params: { id, projectId },
  });
  return data.data;
};

export const addTaskSubmittal = async (submittalData) => {
  const data = await axios({
    method: "post",
    url: HOST_URL + "/projects/addProjectAssetTaskSubmittal",
    withCredentials: true,
    data: { submittalData },
  });
  return data.data;
};

export const updateSubmittalWithFile = async (formData) => {
  const data = await axios({
    method: "post",
    url: HOST_URL + "/projects/updateSubmittalWithFile",
    headers: { "content-type": "multipart/form-data" },
    withCredentials: true,
    data: formData,
  });
  return data.data;
};

export const updateCadTemplateFile = async (formData) => {
  const data = await axios({
    method: "post",
    url: HOST_URL + "/projects/updateCadTemplateFile",
    headers: { "content-type": "multipart/form-data" },
    withCredentials: true,
    data: formData,
  });
  return data.data;
};

export const getAllSubmittals = async (projectId) => {
  const data = await axios({
    method: "get",
    url: HOST_URL + "/projects/getProjectAssetTaskSubmittals",
    withCredentials: true,
    params: { projectId },
  });
  return data.data;
};

export const getAllProjectReviews = async (projectId) => {
  const data = await axios({
    method: "get",
    url: HOST_URL + "/projects/getProjectAssetTaskReviews",
    withCredentials: true,
    params: { projectId },
  });
  return data.data;
};

export const deleteSubmittal = async (id, projectId) => {
  const data = await axios({
    method: "post",
    url: HOST_URL + "/projects/deleteSubmittal",
    withCredentials: true,
    params: { id, projectId },
  });
  return data.data;
};

export const addProject = async (accProject) => {
  const data = await axios({
    method: "post",
    url: HOST_URL + "/projects/addProject",
    withCredentials: true,
    data: { newProject: accProject },
  });
  return data.data;
};

export const addLegacyProject = async (accProject) => {
  const data = await axios({
    method: "post",
    url: HOST_URL + "/projects/addLegacyProject",
    withCredentials: true,
    data: { newProject: accProject },
  });
  return data.data;
};

// export const updateDocStatus = async (type, docList) => {
//   const data = await axios({
//     method: "post",
//     url: HOST_URL + "/projects/updateStatus",
//     withCredentials: true,
//     data: { type, docList },
//   });
//   return data;
// };

export const addProjectAssetTaskReview = async (reviewData) => {
  const data = await axios({
    method: "post",
    url: HOST_URL + "/projects/addProjectAssetTaskReview",
    withCredentials: true,
    data: { reviewData },
  });
  return data;
};

export const fetchDrawingSets = async (projectId) => {
  const data = await axios({
    method: "get",
    url: HOST_URL + "/forgedata/fetchDrawingSets",
    withCredentials: true,
    params: { projectId },
  });
  return data;
};

export const fetchMviewLegacyProjects = async () => {
    const data = await axios({
    method: "get",
    url: HOST_URL + "/projects/getLegacyProjects",
    withCredentials: true,
  });
  return data;
 }

export   const fetchLegacyModels = async (projectId) => {
    const data = await axios.get(HOST_URL + "/forgeData/getLegacyModels", {
      withCredentials: true,
      params: {
        projectId,
      },
    });
    return data.data;
  };

export const fetchMviewRegions = async () => {
  const data = await axios({
    method: "get",
    url: HOST_URL + "/projects/getAllRegions",
    withCredentials: true,
  });
  return data;
};

export const fetchMviewRegion = async (regionCode) => {
  const data = await axios({
    method: "get",
    url: HOST_URL + "/projects/getRegion",
    withCredentials: true,
    params: { regionCode },
  });
  return data;
};

export const updateProjectAssetSheets = async (
  selectedDiscipline,
  status,
  selectedSheet,
) => {
  const data = await axios({
    method: "post",
    url: HOST_URL + "/projects/updateProjectAssetSheet",
    withCredentials: true,
    data: { selectedDiscipline, status, selectedSheet },
  });
  return data;
};

export const updateProjectAssetSheetConfig = async (selectedSheet) => {
  const data = await axios({
    method: "post",
    url: HOST_URL + "/projects/updateProjectAssetSheetConfig",
    withCredentials: true,
    data: { selectedSheet },
  });
  return data;
};

export const refreshSheets = async (projectAssetSetId) => {
  const data = await axios({
    method: "get",
    url: HOST_URL + "/projects/refreshSheets",
    withCredentials: true,
    params: { projectAssetSetId },
  });
  return data;
};
export const getProjectChecklists = async (projectId) => {
  const data = await axios({
    method: "get",
    url: HOST_URL + "/projects/getProjectChecklists",
    withCredentials: true,
    params: { id: projectId },
  });
  return data.data;
};

export const addProjectChecklists = async (projectId, checklistId, emailId) => {
  const data = await axios({
    method: "post",
    url: HOST_URL + "/projects/addProjectChecklists",
    withCredentials: true,
    data: { projectId, checklistId, emailId },
  });
  return data.data;
};

export const updateProjectObjectData = async (projectId, tempData) => {
  const data = await axios({
    method: "post",
    url: HOST_URL + "/projects/updateProjectObjectData",
    withCredentials: true,
    data: { projectId, data: tempData },
  });
  return data.data;
};

export const getProjectStaticData = async (muids) => {
  const data = await axios({
    method: "post",
    url: HOST_URL + "/projects/getProjectStaticData",
    withCredentials: true,
    data: { muids },
  });
  return data.data;
};

export const getProjectDynamicData = async (projectId) => {
  const data = await axios({
    method: "get",
    url: HOST_URL + "/projects/getProjectDynamicData",
    withCredentials: true,
    params: { id: projectId },
  });
  return data.data;
};

export const getProjectTypes = async (regionCode) => {
  const data = await axios({
    method: "get",
    url: HOST_URL + "/projects/getProjectTypes",
    withCredentials: true,
    params: { regionCode },
  });
  return data;
};

export const getAssetFilters = async (regionCode, id) => {
  const data = await axios({
    method: "get",
    url: HOST_URL + "/projects/getAssetFilters",
    withCredentials: true,
    params: { regionCode, id },
  });
  return data;
};

export const getSiteTypes = async (regionCode, projectTypeCode) => {
  const data = await axios({
    method: "get",
    url: HOST_URL + "/projects/getSiteTypes",
    withCredentials: true,
    params: { regionCode, projectTypeCode },
  });
  return data;
};

export const getSiteLocations = async (regionCode) => {
  const data = await axios({
    method: "get",
    url: HOST_URL + "/projects/getSiteLocations",
    withCredentials: true,
    params: { regionCode },
  });
  return data.data;
};

export const getDisciplines = async (regionCode) => {
  const data = await axios({
    method: "get",
    url: HOST_URL + "/projects/getDisciplines",
    withCredentials: true,
    params: { regionCode },
  });
  return data.data;
};

export const getAllRegionCompanies = async (regionCode) => {
  const data = await axios({
    method: "get",
    url: HOST_URL + "/projects/getRegionCompanies",
    withCredentials: true,
    params: { regionCode },
  });
  return data.data;
};

export const getRegionStatuses = async (regionCode) => {
  const data = await axios({
    method: "get",
    url: HOST_URL + "/projects/getRegionStatuses",
    withCredentials: true,
    params: { regionCode },
  });
  if (data?.data && Array.isArray(data.data)) {
    data.data.sort((a, b) => a.id - b.id);
  }
  return data.data ? data.data : [];
};

export const getProjectMaintenance = async (projectId) => {
  const data = await axios({
    method: "get",
    url: HOST_URL + "/projects/getProjectMaintenance",
    withCredentials: true,
    params: { id: projectId },
  });
  return data.data;
};

export const updateProjectObjectsTag = async (projectId, guid, tag) => {
  const data = await axios({
    method: "put",
    url: HOST_URL + "/projects/updateProjectObjectsTag",
    withCredentials: true,
    params: { projectId, guid, tag },
  });
  return data.data;
};

export const getAllSurveys = async (regionCode) => {
  const data = await axios({
    method: "get",
    url: HOST_URL + "/projects/getAllSurveys",
    withCredentials: true,
    params: { regionCode },
  });
  if (data?.data && Object.keys(data.data).length === 0) {
    return [];
  } else {
    const sortedData = data?.data?.sort((a, b) => a.name.localeCompare(b.name));
    return sortedData;
  }
};

export const getMarkupById = async (markupId) => {
  const data = await axios({
    method: "get",
    url: HOST_URL + "/markups/getMarkupById",
    withCredentials: true,
    params: { markupId },
  });
  return data;
};

export const saveView = async (payload) => {
  const data = await axios({
    method: "post",
    url: HOST_URL + "/views/saveView",
    withCredentials: true,
    data: payload,
  });
  return data.data;
};

export const getViews = async (projectId) => {
  const data = await axios({
    method: "get",
    url: HOST_URL + "/views/getViews",
    withCredentials: true,
    params: { projectId },
  });
  return data.data;
};

export const deleteView = async (id, projectId) => {
  const data = await axios({
    method: "delete",
    url: HOST_URL + `/views/deleteView/${id}`,
    withCredentials: true,
    params: { projectId },
  });
  return data.data;
};
